import { z } from "zod";

export const calendarSchema = z.object({
	id: z.string().uuid(),
	entityId: z.string().uuid(), // Represents the UUID part of the morphs
	entityType: z.string(), // Represents the type part of the morphs
	name: z.string(),
	type: z.string(),
	color: z.string().nullable(),
	isDefault: z.boolean().default(false),
	isShared: z.boolean().default(false),
	deletedAt: z.string().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});

export type Calendar = z.infer<typeof calendarSchema>;
